module.exports = __webpack_public_path__ + "img/person_placeholder.7894e7e4.png";